export function isRtlEnabled(): boolean {
  return document.documentElement.getAttribute('dir') === 'rtl';
}
